export const AdItems = {
  rails: { item_id: '1', price: 174900 },
  iphone: { item_id: '4', price: 174900 },
  webdesign: { item_id: '6', price: 174900 },
  android: { item_id: '7', price: 174900 },
  appdesign: { item_id: '9', price: 174900 },
  webdirection: { item_id: '10', price: 174900 },
  webmarketing: { item_id: '11', price: 174900 },
  frontend: { item_id: '12', price: 174900 },
  unity: { item_id: '13', price: 174900 },
  excel2013: { item_id: '17', price: 0 },
  word2013: { item_id: '18', price: 0 },
  powerpoint2013: { item_id: '19', price: 0 },
  access2013: { item_id: '20', price: 0 },
  'excel2013-expert': { item_id: '21', price: 0 },
  'word2013-expert': { item_id: '22', price: 0 },
  photoshop: { item_id: 'training_23', price: 53900 },
  'first-programming': { item_id: '24', price: 174900 },
  'htmlcss-trial': { item_id: 'training_25', price: 0 },
  java: { item_id: '26', price: 0 },
  php: { item_id: '27', price: 174900 },
  'first-programming-lite': { item_id: '28', price: 229900 },
  scala: { item_id: '29', price: 174900 },
  'order-made': { item_id: '30', price: 229900 },
  python: { item_id: '31', price: 174900 },
  'node-js': { item_id: '32', price: 174900 },
  blockchain: { item_id: '33', price: 174900 },
  ai: { item_id: '34', price: 174900 },
  'java-servlet': { item_id: '35', price: 174900 },
  'excel2013-professional': { item_id: '36', price: 0 },
  'blockchain-basic': { item_id: '37', price: 174900 },
  meetup: { item_id: 'training_38', price: 53900 },
  scratch: { item_id: '39', price: 229900 },
  videoediting: { item_id: '40', price: 174900 },
  gas: { item_id: '41', price: 174900 },
  datascience: { item_id: '42', price: 174900 },
  jobchange: { item_id: '43', price: 229900 },
  'jobchange-trial': { item_id: 'training_44', price: 53900 },
  csharp: { item_id: '54', price: 229900 },
  dotnet: { item_id: '55', price: 229900 },
  'first-ai': { item_id: '57', price: 174900 },
  'video-ad': { item_id: '63', price: 427900 },
  azure: { item_id: '64', price: 229900 },
  oop: { item_id: '65', price: 229900 },
  linux: { item_id: '66', price: 229900 },
  sql: { item_id: '69', price: 229900 },
  aws: { item_id: '70', price: 229900 },
  clang: { item_id: '71', price: 229900 },
  angular: { item_id: '73', price: 229900 },
  dle: { item_id: '74', price: 229900 },
  gcp: { item_id: '82', price: 229900 },
  docker: { item_id: '85', price: 229900 },
  'webdesign-freelance': { item_id: '91', price: 330000 },
  'appdesign_training': { item_id: '92', price: 229900 },
  shopify: { item_id: '93', price: 174900 },
  oss: { item_id: '94', price: 174900 },
  security: { item_id: '96', price: 229900 },
  'design-portfolio': { item_id: '97', price: 174900 },
  'webdesign-skillcheck': { item_id: 'training_98', price: 0 },
  'front-freelance': { item_id: '99', price: 330000 },
  'webdevelopment-advanced': { item_id: '135', price: 495000 },
  'rpa-uipath': { item_id: '101', price: 0 },
  'first-dx': { item_id: '102', price: 174900 },
  'dx-management': { item_id: '103', price: 174900 },
  'rails-portfolio': { item_id: '104', price: 174900 },
  'frontend-skillcheck': { item_id: 'training_105', price: 0 },
  wix: { item_id: '106', price: 174900 },
  'first-sidejob': { item_id: '113', price: 439000 },
  'wix-ugooo': { item_id: '114', price: 174900 },
  'first-prompt-eng': { item_id: '130', price: 149600 },
  'frontend-sidejob-skillcheck': { item_id: 'training_115', price: 0 },
  'webrenewal-program': { item_id: 'pack_1', price: 185000 },
  'iphone-renewal-program': { item_id: 'pack_2', price: 185000 },
  'webapp-frontend-set': { item_id: 'pack_4', price: 185000 },
  'php-frontend-set': { item_id: 'pack_5', price: 185000 },
  'iphone-android-set': { item_id: 'pack_6', price: 185000 },
  'unity-android-set': { item_id: 'pack_8', price: 185000 },
  'webapp-frontend-webdesign-set': { item_id: 'pack_9', price: 185000 },
  'php-frontend-webdesign-set': { item_id: 'pack_10', price: 185000 },
  'iphone-android-appdesign-set': { item_id: 'pack_11', price: 185000 },
  'appdesign-iphone-set': { item_id: 'pack_12', price: 185000 },
  'webdesign-webmarketing-set': { item_id: 'pack_13', price: 185000 },
  'unity-iphone-set': { item_id: 'pack_14', price: 185000 },
  'webdirection-webmarketing-set': { item_id: 'pack_15', price: 185000 },
  'webdirection-webdesign-set': { item_id: 'pack_16', price: 185000 },
  'python-ai-set': { item_id: 'pack_17', price: 185000 },
  'blockchain-set': { item_id: 'pack_18', price: 185000 },
  'python-datascience-set': { item_id: 'pack_19', price: 185000 },
  'python-ai-datascience-set': { item_id: 'pack_21', price: 185000 },
  'video-ad-set': { item_id: 'pack_22', price: 185000 },
  'webdesign-freelance-set': { item_id: 'pack_23', price: 185000 },
  'sidejob-bootcamp': { item_id: 'pack_24', price: 185000 },
  'jobchange-bootcamp-program': { item_id: 'pack_25', price: 185000 },
  'frontend-sidejob-set': { item_id: 'pack_29', price: 185000 },
  'potential-sidejob': { item_id: '113', price: 174900 },
  'python-prompt-set': { item_id: 'pack_30', price: 246400 },
  'web-practice-set': { item_id: 'pack_31', price: 839000 },
  'first-sidejob-webdesign-set': { item_id: 'pack_32', price: 723000 },
  'llm-dev': { item_id: '137', price: 149600 },
  'webengineer-jobchange': { item_id: 'pack_33', price: 877800 },
}
